/* eslint-disable no-new */
export const NAVBAR_USER_USER_INFO      = 'NAVBAR_USER_USER_INFO'
export const NAVBAR_USER_TODO_TASK      = 'NAVBAR_USER_TODO_TASK'
export const NAVBAR_USER_MESSAGE        = 'NAVBAR_USER_MESSAGE'
export const NAVBAR_USER_NOTIFY         = 'NAVBAR_USER_NOTIFY'


export const VIP_SET_VIP_INFO           = 'VIP_SET_VIP_INFO'
export const VIP_SET_VIP_SAVED          = 'VIP_SET_VIP_SAVED'

export const VIP_LOOKUP_VIP             = 'VIP_LOOKUP_VIP'
export const VIP_EDIT_VIP               = 'VIP_EDIT_VIP'
export const VIP_CREAT_VIP              = 'VIP_CREAT_VIP'
export const VIP_PREPAY_MONEY       	= 'VIP_PREPAY_MONEY'
export const VIP_PREPAY_MONEY_ADJUST    = 'VIP_PREPAY_MONEY_ADJUST'
export const VIP_AMOUNT_ADJUST          = 'VIP_AMOUNT_ADJUST'
export const USE_AMOUNT_SET             = 'USE_AMOUNT_LESS'

export const PAYINFO_SETTING       = 'PAYINFO_SETTING'
//export const ACTIVE_SALE_TAB_SHEET = 'ACTIVE_SALE_TAB_SHEET'

export const MSG_PAD_SHOW_MESSAGE       = 'MSG_PAD_SHOW_MESSAGE'
export const MSG_PAD_HIDE               = 'MSG_PAD_HIDE'


export const PRODUCTS_SELECT_ALL       = 'PRODUCTS_SELECT_ALL'
export const PRODUCTS_RESPONS_LIST       = 'PRODUCTS_RESPONS_LIST'
export const PRODUCTS_LIST_INC_MUL_INDEX = 'PRODUCTS_LIST_INC_MUL_INDEX'
export const PRODUCTS_LIST_CLEAN         = 'PRODUCTS_LIST_CLEAN'
export const PRODUCTS_DISCOUNT_SELECTED  = 'PRODUCTS_DISCOUNT_SELECTED'


export const PRODUCTS_PREPARE_LIST       = 'PRODUCTS_PREPARE_LIST'
export const PRODUCTS_PREPARE_CLEAN      = 'PRODUCTS_PREPARE_CLEAN'

export const USE_PREPAY_MONEY      = 'USE_PREPAY_MONEY'


export const PRODUCTS_EDIT_ITEM       = 'PRODUCTS_EDIT_ITEM'
export const PRODUCTS_EDIT_NOTE       = 'PRODUCTS_EDIT_NOTE'
export const PRODUCTS_NEW_ORDER_ID    = 'PRODUCTS_NEW_ORDER_ID'
export const PRODUCTS_RESET_VIP_PRICE = 'PRODUCTS_RESET_VIP_PRICE'
export const PRODUCTS_RESTORE_LIST    = 'PRODUCTS_RESTORE_LIST'



export const SAVE_ORDER_TO_BACKUP    = 'SAVE_ORDER_TO_BACKUP'
export const TAKE_ORDER_BY_BACKUP    = 'TAKE_ORDER_BY_BACKUP'
export const REMOVE_BACKUP_ORDER     = 'REMOVE_BACKUP_ORDER'






export const SHOW_DIALOG_REQUEST = 'SHOW_DIALOG_REQUEST'
export const SHOW_DIALOG_DESTROY = 'SHOW_DIALOG_DESTROY'
export const SHOW_DIALOG_SHIPOUT = 'SHOW_DIALOG_SHIPOUT'
export const SHOW_DIALOG_EDITVIP = 'SHOW_DIALOG_EDITVIP'
export const SHOW_DIALOG_SAVED_ORDER = 'SHOW_DIALOG_SAVED_ORDER'
export const SHOW_DIALOG_TAKE_CASH = 'SHOW_DIALOG_TAKE_CASH'
export const SHOW_DIALOG_SHOP_COST = 'SHOW_DIALOG_SHOP_COST'




export const ERROR_MSG_NETWORK          = 'ERROR_MSG_NETWORK'




// WEBPACK FOOTER //
// ./src/store/mutation-define.js